export const InputData = [
	{
		id: 1,
		title: "DATE / TIME",
		type: "text",
		name: "date",
	},

	{
		id: 2,
		title: "PRODUCT NAME",
		type: "text",
		name: "productName",
	},

	{
		id: 3,
		title: "SHELF-LIFE",
		type: "text",
		name: "shelfLife",
	},

	{
		id: 4,
		title: "ADMIN",
		type: "text",
		name: "admin",
	},

	{
		id: 5,
		title: "CATEGORY",
		type: "text",
		name: "category",
	},

	{
		id: 15,
		title: "SUB-CATEGORY",
		type: "text",
		name: "sub-category",
	},

	{
		id: 7,
		title: "BRAND",
		type: "text",
		name: "brand",
	},

	{
		id: 8,
		title: "MODEL",
		type: "text",
		name: "model",
	},

	{
		id: 6,
		title: "AMOUNT",
		type: "tel",
		name: "amount",
	},

	{
		id: 9,
		title: "YEAR",
		type: "tel",
		name: "year",
	},

	{
		id: 10,
		title: "TOTAL UNITS",
		type: "number",
		name: "totalUnits",
	},

	{
		id: 11,
		title: "AVAILABLE UNITS",
		type: "number",
		name: "availableUnits",
	},

	{
		id: 12,
		title: "CONDITION",
		type: "text",
		name: "condition",
	},

	{
		id: 13,
		title: "COLOR",
		type: "text",
		name: "color",
	},

	{
		id: 14,
		title: "PICKUP ADDRESS",
		type: "text",
		name: "pickupAddress",
	},

	// {
	//     id: 14,
	//    title: "TAGS",
	//    type: "text",
	//    name: "tags"
	// },
];

export const ordersInputData = [
	{
		id: 1,
		title: "DATE / TIME",
		type: "text",
		name: "date",
	},

	{
		id: 2,
		title: "TRANSACTION-ID",
		type: "text",
		name: "transactionId",
	},

	{
		id: 3,
		title: "ASSET",
		type: "text",
		name: "asset",
	},

	{
		id: 4,
		title: "VALUE",
		type: "text",
		name: "value",
	},

	{
		id: 5,
		title: "PAYMENT TYPE",
		type: "text",
		name: "paymentType",
	},

	{
		id: 6,
		title: "PAYMENT METHOD",
		type: "text",
		name: "paymentMethod",
	},

	{
		id: 7,
		title: "PAYMENT",
		type: "text",
		name: "amount",
	},

	{
		id: 8,
		title: "OUTSTANDING",
		type: "text",
		name: "outstanding",
	},

	{
		id: 9,
		title: "SALE STATUS",
		type: "text",
		name: "saleStatus",
	},
];
